import { goToNews } from '@/app/routing/events'
import { useStyles } from './styles'
import { useUnit } from 'effector-react'
import { $userLanguage } from '@/entities/user'
import { lang } from '@/shared/constants/lang'

export const GigiNews = () => {
  const { classes } = useStyles()
  const userLang = useUnit($userLanguage)
  const text = lang[userLang].news.gigi
  return (
    <div
      className={classes.root}
      onClick={() => goToNews({ variant: 'gigi' })}
    >
      <p className={classes.title}>{text.preview.title}</p>
      <p className={classes.description}>{text.preview.description}</p>
    </div>
  )
}
